export const DefaultTheme = {
  "NAME": "iPortal",
  "TITLE": "Informance iPortal",
  "DESC": "Informance iPortal.",
  "COLOR": "red",
  "HEADER_CSS": "",
  "LOGIN_IMG": "statics/img/logo/iportal.svg",
  "LOGIN_WALL": "statics/img/wallpaper/skyline_vienna.jpg",
  "AUTO_LOGIN_AS": "",
  "VIEWMODE_SUPPORT": true,
  "GMAP_API": "",
  "ALLOW_REMOTE_LOGIN": false,
  "LLOWED_ORIGINS": [],
  "MANIFEST": {
    "name": "iPortal",
    "short_name": "iPortal",
    "description": "Frontend für Informance ONE Portal Server",
    "display": "standalone",
    "orientation": "portrait",
    "background_color": "#FF0000",
    "theme_color": "#027be3",
    "start_url": ""
  }
}

Object.freeze(DefaultTheme)
